import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usePrefs } from "@/lib/context";

const TONES = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  red: "bg-rose-50 text-rose-700 border-rose-200",
  amber: "bg-amber-50 text-amber-800 border-amber-200",
  blue: "bg-blue-50 text-blue-700 border-blue-200",
  slate: "bg-slate-100 text-slate-700 border-slate-300",
  violet: "bg-indigo-50 text-indigo-700 border-indigo-200",
  dark: "bg-slate-900 text-white border-slate-900",
};
const MAP = {
  ouvert: "amber", attribue: "violet", en_cours: "blue", resolu: "green", cloture: "slate",
  basse: "slate", normale: "blue", haute: "amber", urgente: "red",
  paid: "green", pending: "amber", unpaid: "red", occupe: "green", vacant: "amber", commun: "slate",
  validated: "green", rejected: "red", active: "green", terminated: "slate",
};

export function StatusBadge({ value, label, testId }) {
  const { t } = usePrefs();
  const text = label || (value === "unpaid" ? t("unpaid_s") : value === "pending" && !label ? t("pending") : t(value));
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-sm border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${TONES[MAP[value] || "slate"]}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {text}
    </span>
  );
}

export function Money({ amount, currency, testId, showContract = true }) {
  const { money, convert, fmt, t } = usePrefs();
  const converted = convert(amount, currency) != null;
  return (
    <span data-testid={testId} className="font-data" title={converted ? `${t("contract")} : ${fmt(amount, currency)}` : undefined}>
      {converted && "≈ "}{money(amount, currency)}
      {converted && showContract && <span className="ml-1 text-[10px] text-slate-400">({fmt(amount, currency)})</span>}
    </span>
  );
}

export function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <div className="rise mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && <div className="eyebrow mb-2">{eyebrow}</div>}
        <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">{title}</h1>
        {subtitle && <p className="mt-2 text-sm text-slate-500">{subtitle}</p>}
      </div>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>
  );
}

export function Empty({ text }) {
  const { t } = usePrefs();
  return <div className="rounded-sm border border-dashed border-slate-300 bg-white p-10 text-center text-sm text-slate-500">{text || t("noData")}</div>;
}

export function AuthImage({ path, className, alt = "" }) {
  const [src, setSrc] = useState(path?.startsWith("http") ? path : null);
  useEffect(() => {
    if (!path || path.startsWith("http")) return;
    let url;
    api.get(`/files/${path}`, { responseType: "blob" }).then((r) => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => {});
    return () => url && URL.revokeObjectURL(url);
  }, [path]);
  return src ? <img src={src} alt={alt} className={className} /> : <div className={`${className} animate-pulse bg-slate-200`} />;
}
